import axios from 'axios';
import { UserManager, WebStorageStateStore, Log } from 'oidc-client';
import { IDENTITY_CONFIG, METADATA_OIDC, unauthorizedRoute } from '../configurations/constantes';

class AutenticacaoService {
  UserManager;
  accessToken;

  constructor() {
    this.UserManager = new UserManager({
      ...IDENTITY_CONFIG,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      metadata: {
        ...METADATA_OIDC
      }
    });

    Log.logger = console;
    Log.level = Log.DEBUG;

    this.UserManager.events.addUserLoaded(user => {
      this.accessToken = user.access_token;
      localStorage.setItem("access_token", user.access_token);
      this.setUserInfo({
        accessToken: this.accessToken,
        idToken: user.id_token
      });
      if (window.location.href.indexOf("signin-oidc") !== -1) {
        this.navigateToScreen();
      }
    });

    this.UserManager.events.addSilentRenewError(e => {
    });

    this.UserManager.events.addAccessTokenExpired(() => {
      this.signinSilent();
    });
    this.setAuthInterceptors();
  }

  signinRedirectCallback = () => {
    this.UserManager.signinRedirectCallback().then(() => {
      const token = localStorage.getItem("access_token");

      axios.get(`${process.env.REACT_APP_API_URL}/profile`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "client_id": process.env.REACT_APP_SENSEDIA_CLIENT_ID
          }
        }).then((response) => {
          const {
            idUsuario,
            primeiroNomeUsuario,
            role,
            multiEmpresa,
            codigoEmpresa,
            razaoSocial,
            acessoCarroConectado
          } = response.data;

          localStorage.setItem('user_data', JSON.stringify({
            idUsuario,
            primeiroNomeUsuario,
            role,
            multiEmpresa,
            codigoEmpresa,
            razaoSocial,
            login: true,
            acessoCarroConectado
          }));

          this.setAuthInterceptors()
            .then(() => {
              if (multiEmpresa) {
                window.location.replace(`${process.env.REACT_APP_ROOT_URL}/selecao-empresa`);
              } else {
                window.location.replace(process.env.REACT_APP_ROOT_URL);
              }
            });
        }).catch((error) => {
          if (error.response.status === 403) {
            localStorage.removeItem("access_token");
            localStorage.removeItem('user_data');
            window.location.replace(unauthorizedRoute);
          }
        });
    }).catch(() => {
      window.location.replace(process.env.REACT_APP_ROOT_URL);
    });
  };

  getUser = async () => {
    const user = await this.UserManager.getUser();
    if (!user) {
      return await this.UserManager.signinRedirectCallback();
    }
    return user;
  };

  parseJwt = token => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  };

  setUserInfo = authResult => {
    const data = this.parseJwt(this.accessToken);
    this.setSessionInfo(authResult);
    this.setUser(data);
  };

  signinRedirect = () => {
    localStorage.setItem("redirectUri", window.location.pathname);
    this.UserManager.signinRedirect();
  };

  setUser = data => {
    localStorage.setItem("userId", data.sub);
  };

  setAuthInterceptors = () => {
    const token = localStorage.getItem("access_token");

    if (token) {
      axios.interceptors.request.use(config => {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.client_id = process.env.REACT_APP_SENSEDIA_CLIENT_ID;

        return config;
      }, error => {
        if (process.env.REACT_APP_RELEASE !== 'production') {
          console.log(error);
        }
        return Promise.reject(error);
      });

      axios.interceptors.response.use(response => {
        return response;
      }, error => {
        if (error.response.status === 401) {
          this.signinRedirect();
        }
        if (process.env.REACT_APP_RELEASE !== 'production') {
          console.log(error);
        }
        return Promise.reject(error);
      });
    }

    return new Promise((resolve) => { resolve(true); });
  }

  navigateToScreen = () => {
    const redirectUri = !!localStorage.getItem("redirectUri")
      ? localStorage.getItem("redirectUri")
      : "/en/dashboard";
    const language = "/" + redirectUri.split("/")[1];

    window.location.replace(language + "/dashboard");
  };

  setSessionInfo(authResult) {
    localStorage.setItem("access_token", authResult.accessToken);
  }

  isAuthenticated = () => {
    const access_token = localStorage.getItem("access_token");
    return !!access_token;
  };

  signinSilent = () => {
    this.UserManager.signinSilent()
      .then(user => {
      })
      .catch(err => {
      });
  };

  signinSilentCallback = () => {
    this.UserManager.signinSilentCallback();
  };

  createSigninRequest = () => {
    return this.UserManager.createSigninRequest();
  };

  logout = () => {
    this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem("id_token")
    });
    this.UserManager.clearStaleState();
  };

  signoutRedirectCallback = () => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.removeItem("access_token");
      localStorage.removeItem('user_data');

      this.UserManager.signinRedirect();
    });

    this.UserManager.clearStaleState();
  };
}

export default AutenticacaoService;